import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Modal from '../components/Modal';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const SubtopicMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const initialFormState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subTopicName: '',
        details: '',
        subjectMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")
    const navigate = useNavigate();

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNewSubTopic, setAddNewSubTopic] = useState(false);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subTopicNameSort, setSubTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["subTopicMasterSyllabusStructureMasterDetails.syllabusStructureName", "subjectMasterDetails.subjectName", "subTopicMasterLessonMasterDetails.lessonName", "topicMasterDetails.topicName", "subTopicName"];

    const [loading, setLoading] = useState(false);
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
        getSubtopicList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        if (subtopicData.syllabusStructureMasterId !== '' && subtopicData.subjectMasterId !== '') {
            // Construct the API URL when syllabusData changes
            let apiUrl = '/get-sub-topic-master-list?';

            if (subtopicData.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureId=${subtopicData.syllabusStructureMasterId}&`;
            }

            if (subtopicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`
            }

            if (subtopicData.lessonMasterId) {
                apiUrl += `lessonId=${subtopicData.lessonMasterId}&`;
            }

            if (subtopicData.topicMasterId) {
                apiUrl += `topicId=${subtopicData.topicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.syllabusStructureMasterId !== '' && subtopicData.subjectMasterId !== '') {
                setCurrPage(1);
                setSubtopicList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (subtopicData.syllabusStructureMasterId !== '' && subtopicData.subjectMasterId !== '') {
            authorizedAxios && authorizedAxios.get(getApiUrl())
                .then(response => {
                    setSubtopicList(response.data.result);
                })
                .catch(error => {
                    setSubtopicList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', error);
                });
        }
    }, [subtopicData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewSubTopic])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }

    const getSubtopicList = () => {
        if (subtopicData.syllabusStructureMasterId !== '' && subtopicData.subjectMasterId !== '') {
            authorizedAxios && authorizedAxios.get(getApiUrl())
                .then(response => {
                    setSubtopicList(response.data.result)
                    setAddNewSubTopic(!addNewSubTopic)
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                });
        }
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                details: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subjectMasterId: ''
            }
        })

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: ''
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${subtopicData.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;

        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: ''
            }
        })
        const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error

    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(subtopicData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (subtopicData[key] == '' || subtopicData[key]?.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }

    }, [subtopicData])

    const addTopic = () => {
        const apiUrl = `/add-sub-topic-master`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, subtopicData)
                .then(response => {
                    getSubtopicList();
                    setSubtopicData((prevData) => {
                        return {
                            ...prevData,
                            subTopicName: '',
                            details: ''
                        }
                    })
                    setSaveId(response.data.result[0].id);
                    setSyllabusStructureNameSort(null);
                    setSubjectSort(null);
                    setLessonNameSort(null);
                    setTopicNameSort(null);
                    setSubTopicNameSort(null);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                }
                else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSubtopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-sub-topic-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSubtopic = () => {
        setLoading(true);
        const apiUrl = `/edit-sub-topic-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, subtopicData)
            .then(response => {
                getSubtopicList();
                setSaveId(response.data.result[0].id);
                setEditId(null);
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        subTopicName: '',
                        details: ''
                    }
                })

                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err.response.data.message);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    const reset = () => {
        setSubtopicData(initialFormState);
        setSubtopicList([])
        setEditId('')
        setSyllabusStructureNameSort(null);
        setSubjectSort(null);
        setLessonNameSort(null);
        setTopicNameSort(null);
        setSubTopicNameSort(null);
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setSubTopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subTopicNameSort == true || subTopicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [subTopicNameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Sub Topic</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-info"></i> Sub Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusStructureMasterId && <p style={{ color: 'red' }}>{error.syllabusStructureMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={subtopicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}

                                                </div>


                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={subtopicData.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.lessonMasterId && <p style={{ color: 'red' }}>{error.lessonMasterId}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleInputChange} value={subtopicData.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.topicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.topicMasterId && <p style={{ color: 'red' }}>{error.topicMasterId}</p>}

                                                </div>

                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Name :</label>
                                                    <input required type="text" className="form-control" id="subTopicName" name='subTopicName' onChange={handleInputChange} value={subtopicData.subTopicName} />
                                                    {error.subTopicName && <p style={{ color: 'red' }}>{error.subTopicName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Details :</label>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={subtopicData.details}
                                                        onReady={editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            // console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            // console.log(event)
                                                            handleDetailChange(editor)
                                                        }}

                                                        config={{
                                                            extraPlugins: [uploadPlugin],
                                                        }}

                                                        onInit={(editor) => {
                                                            // Register the custom upload adapter
                                                            uploadPlugin(editor);
                                                        }}
                                                    />
                                                    {error.details && <p style={{ color: 'red' }}>{error.details}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <div className='table-header-like'> Sub Topic Details</div>

                                                        {/* <DecodedHTMLComponent data={modalData} /> */}

                                                        <div className="page" dangerouslySetInnerHTML={{
                                                            __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">

${modalData}</div>`
                                                        }}></div>

                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>

                                                </CModal>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subTopicMasterSyllabusStructureMasterDetails.syllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subTopicMasterLessonMasterDetails.lessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"topicMasterDetails.topicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subTopicNameSort} setSortState={setSubTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.subTopicMasterSyllabusStructureMasterDetails?.syllabusStructureName}</td>
                                                                                        <td>{subtopic?.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.subTopicMasterLessonMasterDetails?.lessonName}</td>
                                                                                        <td>{subtopic?.topicMasterDetails?.topicName}</td>
                                                                                        <td>{subtopic?.subTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSubtopicData({
                                                                                                    subTopicNo: subtopic.subTopicNo,
                                                                                                    details: subtopic.details,
                                                                                                    subTopicName: subtopic.subTopicName,
                                                                                                    lessonMasterId: subtopic.subTopicMasterLessonMasterDetails?.id,
                                                                                                    topicMasterId: subtopic.topicMasterDetails?.id,
                                                                                                    syllabusStructureMasterId: subtopic.subTopicMasterSyllabusStructureMasterDetails?.id,
                                                                                                    subjectMasterId: subtopic.subjectMasterDetails.id

                                                                                                });
                                                                                                setEditId(subtopic.id)
                                                                                                setTopicList([{
                                                                                                    id: subtopic.topicMasterDetails?.id,
                                                                                                    topicName: subtopic.topicMasterDetails?.topicName
                                                                                                }]);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>



                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setVisible(!visible)
                                                                                                setModalData(subtopic.details)
                                                                                            }}><i class="fa fa-eye" ></i></button>


                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === subtopic.id} onClick={() => deleteSubtopic(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SubtopicMaster;